import {Popout} from '../../popout'
import {EitjeButton} from '../components'

export const DeleteButton = ({
	afterDel,
	nonDestructive,
	height,
	confirmText,
	confirmTitle,
	deleteButtonProps,
	t = 'delete',
	children,
	onDel,
	onClick,
	baseColor = 'red',
	disabled,
	...rest
}) => {
	if (!onDel) onDel = onClick

	const _onDel = async e => {
		await onDel(e)
		afterDel && afterDel()
	}

	const condOpts = {}
	if (confirmText) condOpts['body'] = confirmText
	if (confirmTitle) condOpts['title'] = confirmTitle

	return (
		<Popout
			type="delete"
			trigger={
				<EitjeButton
					className="eitje-delete-button"
					height={height}
					iconLeft="trash"
					baseColor={baseColor}
					t={t}
					{...rest}
					disabled={disabled}
				>
					{children}
				</EitjeButton>
			}
			onDelete={_onDel}
			deleteButtonProps={deleteButtonProps}
			{...condOpts}
			title={confirmTitle}
			nonDestructive={nonDestructive}
		/>
	)
}
